import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    identifier: String
  }

  open(e) {
    // The header search icon is global, but the filter modal (#def) only exists
    // on the results page. When it's here, open it in place (and focus the box);
    // anywhere else, do nothing and let the link navigate to /videos?open_search=1,
    // where modal-filters#connect opens it on arrival.
    const host = document.querySelector(`#${this.identifierValue}`);
    if (host && host.modal) host.modal.open(e);
  };
}
